interface PropsType {
  colSpan?: number;
  msg?: string;
}

export default function EmptyTableRow({ colSpan, msg }: PropsType) {
  return (
    <tr>
      <td className="text-center" colSpan={colSpan ?? 100}>
        {msg ?? "조회된 데이터가 없습니다."}
      </td>
    </tr>
  );
}
